import React, { useMemo } from "react";
import Pagination_Holder from "../../../../../../common/common_components/pagination_holder/Pagination_Holder";
import { formatDate } from "../../../../../../utils/common";

const Quality_Control_Plan_Table = ({
  setEdit,
  quality_control_plan,
  currentPage,
  setCurrentPage,
}) => {
  const itemsPerPage = 10;

  const data = quality_control_plan?.data || [];
  const totalPages = quality_control_plan?.total_pages || 0;

  /* =============================
     FIND GLOBAL MAX PARAMETERS
  ============================== */
  const maxParameters = useMemo(() => {
    if (!data?.length) return 0;

    return Math.max(
      ...data.map(item => item?.Quality_Parameters?.length || 0)
    );
  }, [data]);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <>
      <div className="common_table_container theme_bg">
        <div className="table-responsive">
          <table className="common_table table table-striped">

            {/* =============================
               CORRECT THEAD (6 COLUMNS)
            ============================== */}
            <thead>
              <tr>
                <th rowSpan="2">Sr. No</th>
                <th rowSpan="2">Date</th>
                <th rowSpan="2">Type Of Verification</th>
                
                <th rowSpan="2">Frequency</th>
                 <th rowSpan="2">Remark</th>
                <th colSpan="2">Acceptance Parameter Criteria</th>
            
      
              </tr>
              <tr>
                <th>Parameter</th>
                <th>Value</th>
              </tr>
            </thead>

            {/* =============================
               TBODY USING MAX PARAMETERS
            ============================== */}
            <tbody>
              {data.length > 0 ? (
                data.map((item, index) => {
                  const parameters = item?.Quality_Parameters || [];

                  // Use global max OR at least 1 row
                  const totalRows = Math.max(maxParameters, 1);

                  return Array.from({ length: totalRows }).map((_, i) => {
                    const param = parameters[i];

                    return (
                      <tr key={`${index}-${i}`}>

                        {/* Parent columns with rowspan */}
                        {i === 0 && (
                          <>
                            <td rowSpan={totalRows}>
                              {(currentPage - 1) * itemsPerPage + index + 1}
                            </td>

                            <td rowSpan={totalRows}>
                              {formatDate(item?.createdAt) || "-"}
                            </td>

                            <td rowSpan={totalRows}>
                              {item?.Type_Of_Verification?.name || "-"}
                            </td>

                            <td rowSpan={totalRows}>
                              {item?.frequency || "-"}
                            </td>

                             <td rowSpan={totalRows}>
                               {item?.remark || "-"}
                            </td>

                            
                          </>
                        )}

                        {/* Parameter columns */}
                        <td>{param?.Parameter?.name || "-"}</td>
                        <td>{param?.value || "-"}</td>



                      </tr>
                    );
                  });
                })
              ) : (
                <tr>
                  <td colSpan="6" className="text-center">
                    No Quality Control Plan data found
                  </td>
                </tr>
              )}
            </tbody>

          </table>
        </div>
      </div>

      {/* =============================
         PAGINATION FOOTER
      ============================== */}
      <div className="comon_page_footer">
        <div className="show_entry_div">
          Showing {(currentPage - 1) * itemsPerPage + 1} to{" "}
          {(currentPage - 1) * itemsPerPage + data.length} of{" "}
          {quality_control_plan?.total || 0} entries
        </div>

        <div className="pagination_div">
          <Pagination_Holder
            onPageChange={currentPage}
            totalPages={totalPages}
            handlePageChange={handlePageChange}
          />
        </div>
      </div>
    </>
  );
};

export default Quality_Control_Plan_Table;